import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAbility } from '@casl/react';
import snakecaseKeys from 'snakecase-keys';
import { sendAlert } from '../../../actions/utils';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal } from '../../../components';

import {
  indexAttendanceChangeRequest,
  approvedAttendanceChangeRequest,
  rejectAttendanceChangeRequest
} from '../../../requests/AttendanceChange';
import ItemsInfo from './Items/ItemsInfo';
import { AbilityContext } from '../../../config/abilityContext';
import AttendanceChageRejectForm from './AttendanceChageRejectForm';

const AttendanceChangeRequestDataTable = ({
  columns,
  defaultStartDate = null,
  defaultEndDate = null,
  moreData,
  preName,
  setMoreData,
  rrhh,
  setWorkflowIds = () => null,
  withDateSelect
}) => {
  const ability = useAbility(AbilityContext);
  const [amount, setAmount] = useState(0);
  const [centerModalShow, setCenterModalShow] = useState(false);
  const [modalAction, setModalAction] = useState(() => null);
  const [modalBody, setModalBody] = useState('');
  const [modalItem, setModalItem] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [onRequest, setOnRequest] = useState(true);
  const [workflowRequests, setWorkflowRequests] = useState([]);
  const dispatch = useDispatch();

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setWorkflowRequests(data);
    setWorkflowIds(data.map(element => element.id));
    setAmount(metadata.amount);
    setOnRequest(false);
  };

  const handleRequest = params => {
    setOnRequest(true);
    const customParams = {
      status: 'pending'
    };
    indexAttendanceChangeRequest({
      dispatch,
      params: { ...params, ...customParams },
      successCallback: handleSuccessIndex
    });
  };

  const handleModalClose = () => {
    setCenterModalShow(false);
    setModalShow(false);
  };

  const handleSuccessApprove = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud aprobada correctamente' }));
    setMoreData(!moreData);
    setOnRequest(false);
    handleModalClose();
  };

  const handleSuccessReject = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud rechazada correctamente' }));
    setMoreData(!moreData);
  };

  const approvedAttendanceChange = item => {
    setOnRequest(true);
    approvedAttendanceChangeRequest(item.id, {
      dispatch,
      successCallback: handleSuccessApprove,
      callback: () => {
        handleModalClose();
        setOnRequest(false);
      }
    });
  };

  const rejectAttendanceChange = (params, setSubmitting) => {
    setOnRequest(true);
    const { id } = params.attendanceChangeRequest;
    rejectAttendanceChangeRequest(id, {
      dispatch,
      params: snakecaseKeys(params),
      successCallback: handleSuccessReject,
      callback: () => {
        handleModalClose();
        setOnRequest(false);
        setSubmitting(false);
      }
    });
  };

  const handleActions = (item, action) => {
    setModalItem({});
    switch (action) {
      case 'show':
        setModalTitle('Corrección de Marcación');
        setModalBody(<ItemsInfo item={item} rrhh={rrhh} />);
        setModalItem(item);
        setCenterModalShow(true);
        break;
      case 'approved':
        setModalTitle('Aprobar Corrección de marcacion de asistencia');
        setModalShow(true);
        setModalBody('¿Estás seguro que deseas aprobar la solicitud?');
        setModalItem(item);
        setModalAction(() => approvedAttendanceChange);
        break;
      case 'rejected':
        setModalTitle('Rechazar Corrección de marcacion de asistencia');
        setModalBody(<AttendanceChageRejectForm attendanceChangeRequest={item} formRequest={rejectAttendanceChange} />);
        setModalItem(item);
        setCenterModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'shift':
        return { sort_shifts: name };
      case 'employee':
        return { sort_employees: name };
      case 'employee_replacement':
        return { sort_employee_replacements: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns(handleActions, ability, rrhh)}
        handleSortCase={sortColumnCase}
        data={workflowRequests}
        totalRows={amount}
        moreData={moreData}
        resourceRequest={handleRequest}
        withStartDate
        withEndDate
        rangePicker
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
        preName={preName || 'attendanceChange'}
        onRowClicked={item => handleActions(item, 'show')}
        pointerOnHover
        withDateSelect={withDateSelect}
      />
      <SimpleCenteredModal
        size="md"
        title={modalTitle}
        body={modalBody}
        show={centerModalShow}
        onHide={handleModalClose}
      />
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={handleModalClose}
        handleConfirm={() => modalAction(modalItem)}
        disabled={onRequest}
        variantBtnClose="outline-info"
        variantBtnSave="primary"
      />
    </>
  );
};

export default AttendanceChangeRequestDataTable;
